import React from 'react';

import Index from 'scripts/frontend/questionnaires/components/Index';
import every from 'lodash/every';
import {connect} from 'react-redux';
import MarkDown from 'scripts/components/MarkDown';


const Home = ({allComplete}) => (
    <div className="home">
        {!allComplete && <MarkDown className="questionnaires-intro" text={window.COVSOCIAL_INTRO} />}

        <Index />

        <footer>
            <a href="/information/">Teilnehmerinformationen</a>
        </footer>
    </div>
)

const mapStateToProps = ({questionnaire}) => ({
    allComplete: every(questionnaire.ids, id => questionnaire[id].completed),
});

export default connect(mapStateToProps, {})(Home);



// WEBPACK FOOTER //
// ./scripts/cov-social/Home.js